const current_location = window.location.href;

let force_development_mode =
  current_location.search("//dev.eprezto.com") > 0 ||
  current_location.search("//localhost") > 0;


let use_inter = true
  /*current_location.search("dev.eprezto.com") > 0 ||
  current_location.search("eprezto.com") > 0 ||
  current_location.search("www.eprezto.com") > 0;*/

  /*if (current_location.search("widget") > 0 || current_location.search(/screen/)) {
    use_inter = false;
  }*/

  let local_mode = current_location.search("localhost") > 0 ? true : false;

  if (current_location.search(/screen/) > 0 || current_location.search("localhost") > 0) {
    use_inter = false;
  }

  console.log('UsuarioIntercom:', use_inter);

/* Aqui se escoge el gateway que se usar para los cobros */
/* NOTA: Si desea usar stripe, tendra entonces que descomentarlo en el index.html del public folder */

/* ******************************************* */
const gateway_platform_used = "cybersource";
/* const gateway_platform_used = "cybersource" */
/* ******************************************* */

/* 
  NOTA: Si descomenta esta linea, todo el codigo se ejecutara 
  como si estuviese en produccion, tenga mucha precaucion ya que puede emitir polizas reales 
  y causar conflictos.
*/

/* ******************************** */
/* force_development_mode = false; */
/* ******************************** */

/* ******************************** */
/* use_inter = true; */
/* ******************************** */ 
export const Eprezto_Settings = {
  PK_DEV: "pk_test_YwMZPZEArI0Q97aLYGMmdSgl",
  PK_PROD: "pk_live_YHmzNqcS7cXjZ2SdBRhViXIn",
  DEVELOPMENT_MODE: force_development_mode ? true : false,
  LOCAL_MODE: local_mode ? true : false,
  USE_INTER: use_inter ? true : false,
  GATEWAY_PLATFORM_USED: gateway_platform_used,
  CYBER_ACCESS_KEY_DEV: "fd525ad35cda3b21a520db6c60b671a3",
  CYBER_ACCESS_KEY_PROD: "1e09be24e55b315c8ec8c63f43c7211f",
  CYBER_URL_POST_DEV: "https://testsecureacceptance.cybersource.com/silent/pay",
  CYBER_URL_POST_PROD: "https://secureacceptance.cybersource.com/silent/pay",
  CYBER_PROFILE_ID_DEV: "8778BDBF-1F9B-4FC1-916B-F2BAD3127235",
  CYBER_PROFILE_ID_PROD: "956A6041-616D-46B6-AE3D-9BBF10C31B81",
};